"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseButton = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _core = require("@emotion/core");

var _styledSystem = require("styled-system");

var _themeGet = require("@styled-system/theme-get");

var _Core = require("../Core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const generateSize = (height, px, font, radius) => props => /*#__PURE__*/(0, _core.css)("min-height:", (0, _themeGet.themeGet)("space.".concat(height))(props), ";padding-top:", (0, _themeGet.themeGet)("space.1")(props), ";padding-bottom:", (0, _themeGet.themeGet)("space.1")(props), ";padding-left:", (0, _themeGet.themeGet)("space.".concat(px))(props), ";padding-right:", (0, _themeGet.themeGet)("space.".concat(px))(props), ";font-size:", (0, _themeGet.themeGet)("fontSizes.".concat(font))(props), ";border-radius:", (0, _themeGet.themeGet)("radii.".concat(radius))(props), ";");

const sizeVariants = props => {
  switch (props.size) {
    case 'small':
      return generateSize(5, 2, 'text-xs', 'radius-1')(props);

    case 'large':
      return generateSize(7, 4, 'text', 'radius-1')(props);

    case 'xlarge':
      return generateSize(9, 6, 'text-l', 'radius-2')(props);

    case 'medium':
    default:
      return generateSize(6, 3, 'text-s', 'radius-1')(props);
  }
};

var _ref = {
  name: "1e57ig3",
  styles: "display:flex;width:100%;text-align:center;"
};

const setBlock = props => props.block && _ref;

var _ref2 = {
  name: "1rc6erl",
  styles: "pointer-events:none;cursor:default;opacity:0.5;box-shadow:none;"
};

const setDisabled = props => props.disabled && _ref2;

const BaseButton = ( /*#__PURE__*/0, _styledBase.default)('button', {
  target: "eyy9x0e0",
  label: "BaseButton"
})("appearance:none;box-sizing:border-box;position:relative;display:inline-flex;align-items:center;justify-content:center;margin:0;line-height:1;user-select:none;text-decoration:none;text-align:center;font-family:", (0, _themeGet.themeGet)('fontFamily.sans-serif'), ";font-weight:", (0, _themeGet.themeGet)('fontWeights.bold'), ";transition-property:background,border,box-shadow,color;transition-duration:", (0, _themeGet.themeGet)('transition.transition-duration-fast'), ";border:1px solid;cursor:pointer;", sizeVariants, ";", setBlock, ";&:disabled{pointer-events:none;cursor:default;opacity:0.5;box-shadow:none;}", setDisabled, ";", (0, _styledSystem.compose)(_styledSystem.space, _Core.border, _styledSystem.layout, _styledSystem.zIndex), ";");
exports.BaseButton = BaseButton;
BaseButton.defaultProps = {
  type: 'button'
};